// src/components/SignInEmailLink.tsx

import { signInWithEmail, verifyCode } from "../../services/authService";



export const verifyEmail = async (email: string) => {
  try {
    const data = await signInWithEmail(email);
    
    return data;
    
  } catch (error) {
    console.error('Error al enviar el enlace de inicio de sesión:', error);
  }
};


export const verifyOtp = async (email: string, otp: string) => {
  try {
    const response = await verifyCode(email, otp);

    if (response && response.status === 200) {
      const { token, message } = response; 


      if (token) {

        return {
          response,
          userData: {
            firstName: token.user.fullName.split(' ')[0],
            lastName: token.user.fullName.split(' ')[1] || '',
            email,  
            phoneNumber: token.user.phoneNumber,  
          },
          message
        };
      } else {
        console.error('No se recibió el token.');
        return null;
      }
    } else {
      console.error('Error en la verificación del OTP:', response ? response.message : 'No se recibió respuesta.');
      return null;
    }

  } catch (error) {
    console.error('Error al verificar el OTP:', error);
    return null;
  }
};

